// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_saturday = /** @type {(inputs: {}) => string} */ () => {
	return `Saturday`
};

const el_saturday = /** @type {(inputs: {}) => string} */ () => {
	return `Σάββατο`
};

const ru_saturday = /** @type {(inputs: {}) => string} */ () => {
	return `Суббота`
};

const he_saturday = /** @type {(inputs: {}) => string} */ () => {
	return `יום שבת`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const saturday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.saturday(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("saturday", locale)
	if (locale === "en") return en_saturday(inputs)
	if (locale === "el") return el_saturday(inputs)
	if (locale === "ru") return ru_saturday(inputs)
	if (locale === "he") return he_saturday(inputs)
	return "saturday"
};